import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from './common.service';
import * as appApiResources from '../globalcontants';
import * as appApi from '../../shared/globalcontants';
import { PopupComponent } from '../popup/popup.component';
@Injectable({
    providedIn: 'root'
})
export class SignalrService {
 
    public hubConnection!: signalR.HubConnection;
    loggedInUserId = 0;
    tenantIdentifier = '';
    private concurrentLoginPopupOpen = false;
 
    constructor(private dialog: MatDialog, private commonService: CommonService,
        private translateService: TranslateService) { }
 
    public startConnection = () => {
        this.loggedInUserId = parseInt(sessionStorage.getItem(appApiResources.loggedInUserId.toString()) || '0', 10) || 0;
        this.tenantIdentifier = localStorage.getItem('tenant') || '';
        console.log('Logged in user ID:', this.loggedInUserId);
        console.log('Tenant identifier:', this.tenantIdentifier);
        const gatewayConfig = this.commonService.GatewayURL.find(config =>
            config.Gateway.trim() === this.commonService.apiUrl?.trim());
        const publisherServiceUrl = gatewayConfig?.PublisherServiceUrl;
        if (!publisherServiceUrl) {
            console.log('PublisherServiceUrl is not configured, skipping SignalR connection');
            return;
        }
        const hubUrl = publisherServiceUrl + `concurrentloginhub?userId=${this.loggedInUserId}`;
        console.log(hubUrl,"huburl")
        this.hubConnection = new signalR.HubConnectionBuilder()
            .configureLogging(signalR.LogLevel.Debug)
            .withUrl(hubUrl, this.getConnectionOptions())
            .withAutomaticReconnect()
            .build();
        this.hubConnection
            .start()
            .then(() => {
                console.log('Connection started');
                
            })
            .catch(err => console.log('Error while starting connection: ' + err));
        console.log('Hub Connection', this.hubConnection);
    }
 public addlistener(){
    this.hubConnection.on('ConcurrentLoginDetected', (payload:any) => {
            console.log('ConcurrentLoginDetected payload:', payload);
                const isSameSession = payload.targetSessionId?.toLowerCase() === localStorage.getItem(appApi.EatecSessionId);
                console.log("targetsessionid", payload.targetSessionId?.toLowerCase());
                console.log("current sessionid", localStorage.getItem(appApi.EatecSessionId));
                if ( !isSameSession) {
                return;
                }
                this.showConcurrentLoginInfoPopup(payload);
        });
 }
    private getConnectionOptions(): signalR.IHttpConnectionOptions {
        const isOnPrem = localStorage.getItem('isOnPrem') === 'true';
        return (!isOnPrem) ? {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets
        } : {};
    }
 
    /** Shows info message when hub starts only if concurrent-login iniConfig is enabled in tenantINIConfig. */
    private showConcurrentLoginInfoPopup(payload: any): any {
        const dialogArray = {
            headerText: 'Concurrent Login Detected',
            contentText: payload.message,
            cancelText: null,
            confirmText: this.translateService.instant('common.ok'),
            cancelHelpText: null,
            confirmHelpText: 'OK',
            strongText: ''
        };

        this.commonService.mobilePopUpProperty.data = dialogArray;
        const dialogRef = this.dialog.open(
            PopupComponent,
            this.commonService.mobilePopUpProperty
        );
        dialogRef.afterClosed().subscribe(() => {
            this.concurrentLoginPopupOpen = false;
        });
        this.concurrentLoginPopupOpen = true;
    }
}
 